import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ai-month-stepper',
  templateUrl: './ai-month-stepper.component.html',
  styleUrls: ['./ai-month-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiMonthStepperComponent {
  @Input() label = '';
  @Input() canStepForward = true;
  @Output() readonly step = new EventEmitter<number>();
}
